/* global $:false, swal:false */
;(function () {
  'use strict'

  angular
    .module('pub.shinies.odds', ['pub.shinies.odds.service'])
    .controller('ShiniesOddsCtrl', ShiniesOddsCtrl)

  /** @ngInject */
  function ShiniesOddsCtrl($scope, $state, $stateParams, ShiniesOddsService, CollectiblesService) {
    var vm = this
    vm.model = {}
    vm.items = []
    vm.isOpen = false
    vm.isOpen1 = false

    var isDate = function (date) {
      return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
    }

    vm.openCalendar = function (e, type) {
      e.preventDefault()
      e.stopPropagation()

      if (type === 1) {
        vm.isOpen = true
        vm.isOpen1 = false
      } else if (type === 2) {
        vm.isOpen = false
        vm.isOpen1 = true
      }
    }

    function load() {
      vm.items = []
      ShiniesOddsService.list($stateParams.shinyId).then(function (result) {
        for (var i = 0; i < result.results.length; i++) {
          if (result.results[i]['ts-start']) {
            result.results[i]['ts-start'] = result.results[i]['ts-start']
              .toString()
              .substring(0, result.results[i]['ts-start'].toString().length - 3)
            result.results[i]['ts-start'] = new Date(parseInt(result.results[i]['ts-start']))
            vm.data1 = angular.copy(result.results[i]['ts-start'])
          }

          if (result.results[i]['ts-end']) {
            result.results[i]['ts-end'] = result.results[i]['ts-end']
              .toString()
              .substring(0, result.results[i]['ts-end'].toString().length - 3)
            result.results[i]['ts-end'] = new Date(parseInt(result.results[i]['ts-end']))
            vm.data2 = angular.copy(result.results[i]['ts-end'])
          } else {
            result.results[i]['ts-end'] = ''
          }

          if (
            result.results[i]['ts-start'] <= new Date() &&
            (!result.results[i]['ts-end'] || result.results[i]['ts-end'] > new Date())
          ) {
            result.results[i].status = 'Published'
          } else if (result.results[i]['ts-start'] <= new Date() && !result.results[i]['ts-end']) {
            result.results[i].status = 'Published'
          } else {
            result.results[i].status = 'Draft'
          }
        }

        var mostRecent = _.orderBy(
          result.results.filter(function (item) {
            return item.status === 'Published'
          }),
          'ts-start',
          'desc',
        )
        if (mostRecent && mostRecent.length > 0) {
          for (var i = 0; i < result.results.length; i++) {
            if (mostRecent[0].id === result.results[i].id) {
              result.results[i].highlight = true
            } else {
              result.results[i].highlight = false
            }
          }
        }
        vm.items = result.results
      })
    }

    vm.delete = function (id) {
      swal(
        {
          title: 'Delete',
          text: 'You want to delete this odds?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            ShiniesOddsService.remove(id).then(function () {
              $state.reload()
            })
          }
        },
      )
    }

    load()

    vm.create = function () {
      vm.model = {}
      vm.data1 = null
      vm.data2 = null
      $('#myModalShiny').modal('show')
    }

    vm.edit = function (item) {
      vm.model = angular.copy(item)
      vm.data1 = vm.model['ts-start']
      vm.data2 = vm.model['ts-end']
      $('#myModalShiny').modal('show')
    }

    vm.save = function () {
      if (vm.model.opm === null || vm.model.opm === undefined) {
        swal('You need select Odd per million!', '', 'warning')
        return
      }

      if (
        !vm.model['ts-start'] !== undefined ||
        vm.model['ts-start'] !== null ||
        vm.model['ts-start'] !== ''
      ) {
        if (isDate(vm.data1)) {
          var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
          if (date === 0) {
            swal('You need select Publish At!', '', 'warning')
            return
          }
          vm.model['ts-start'] = date
        } else {
          swal('You need select Publish At!', '', 'warning')
          return
        }
      } else {
        swal('You need select Publish At!', '', 'warning')
        return
      }

      if (
        vm.model['ts-end'] !== undefined ||
        vm.model['ts-end'] !== null ||
        vm.model['ts-end'] !== ''
      ) {
        if (isDate(vm.data2)) {
          var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
          vm.model['ts-end'] = date
        } else {
          vm.model['ts-end'] = null
        }
      } else {
        vm.model['ts-end'] = null
      }

      if (vm.model['ts-end'] === 0) {
        vm.model['ts-end'] = null
      }

      vm.model['id-shiny'] = parseInt($stateParams.shinyId)

      if (vm.model.id && vm.model.id !== 0) {
        delete vm.model['ts']
        delete vm.model['status']
        ShiniesOddsService.update(vm.model.id, vm.model).then(
          function () {
            $('#myModalShiny').modal('hide')
            vm.model = {}
            swal('Saved!', '', 'success')
            $state.reload()
          },
          function (err) {
            swal(err.error.message, '', 'error')
          },
        )
      } else {
        ShiniesOddsService.save($stateParams.shinyId, vm.model).then(
          function () {
            $('#myModalShiny').modal('hide')
            vm.model = {}
            swal('Saved!', '', 'success')
            $state.reload()
          },
          function (err) {
            swal(err.error.message, '', 'error')
          },
        )
      }
    }

    vm.deleteImage = function (item) {
      vm.model[item] = ''
    }

    function gcd(a, b) {
      if (b > a) {
        var temp = a
        var a = b
        var b = temp
      }
      while (b != 0) {
        var m = a % b
        var a = b
        var b = m
      }
      return a
    }

    vm.ratio = function (x, y) {
      var c = gcd(x, y)
      return '' + x / c + ' in ' + y / c
    }
  }
})()
